<template>
  <div>
    <div class="dg-title">{{ trans("OfferSharingForm.title") }}</div>
        <multiselect v-if="!isIE" v-model="sendingList" track-by="id" label="full_name"
          :placeholder="trans('multiselect.placeholder')" :showLabels="false"
          :multiple="true" :hide-selected="true" :options="managerOptions"
          v-validate="'required'" data-vv-name="managers">
          <span slot="noResult">{{ trans('OfferSharingForm.no_manager') }}</span>
        </multiselect>
        <v-select v-else multiple v-model="sendingListIE" :placeholder="trans('multiselect.placeholder')"
          v-validate="'required'" data-vv-name="managers" :data-vv-as="trans('models.user.managers')"
          :options="managerOptionsIE">
        </v-select>
        <label v-show="errors.has('managers')" id="managers-error" class="error" for="managers">{{ errors.first('managers') }}</label>
        <button @click="shareOffer" class="btn btn-primary btn-cons m-t-15" :options="options">{{ trans("OfferSharingForm.buttons.send") }}</button>
  </div>
</template>

<script type="text/javascript">
  import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
  import i18n from '@/lang'
  import ie_mixin from '@/mixin/ie'
  import AtInternetManager from '@/helpers/at_internet/manage_requests'

  export default {
    name: "OfferSharingForm",
    mixins: [DialogMixin, ie_mixin],
    data: function(){
      return {
        managerOptions: [],
        sendingList: [],
        sendingListIE: []
      }
    },
    computed: {
      managerOptionsIE() {
        return this.managerOptions.map(item => item['full_name'])
      }
    },
    watch: {
      sendingListIE: function (values) {
        var selected = []
        values.map(item => selected.push(this.searchInArray(item, this.managerOptions, 'full_name')))
        this.sendingList = selected
      }
    },
    methods: {
      shareOffer(){
        AtInternetManager.sendShareEmailEvent()
        this.proceed(this.sendingList)
      },
      trans(text){
        return i18n.t(text);
      }
    },
    mounted() {
      this.managerOptions = this.options.managerOptions
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/offers/OfferSharingForm.vue